import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPage as _getPage, getMaterialVideo } from '@/api/wxmp/wxmaterial';
import { getPage as getPageNews } from '@/api/wxmp/wxfreepublish';
import { getPage as getPageNewsDraft } from '@/api/wxmp/wxdraft';
import { tableOptionVoice } from '@/const/crud/wxmp/wxmaterial_voice';
import { tableOptionVideo } from '@/const/crud/wxmp/wxmaterial_video';
import WxNews from '@/components/wx-news/main.vue';
export default {
  name: "wxMaterialSelect",
  components: {
    WxNews: WxNews
  },
  props: {
    appId: {
      type: String
    },
    objData: {
      type: Object
    },
    //图文类型：1、已发布图文；2、草稿箱图文
    newsType: {
      type: String,
      default: "1"
    }
  },
  data: function data() {
    return {
      tableLoading: false,
      tableData: [],
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 20,
        // 每页显示多少条
        ascs: [],
        //升序字段
        descs: [] //降序字段
      },

      tableOptionVoice: tableOptionVoice,
      tableOptionVideo: tableOptionVideo
    };
  },
  created: function created() {
    this.getPage(this.page);
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    selectMaterial: function selectMaterial(item) {
      this.$emit('selectMaterial', item);
    },
    getPage: function getPage(page, params) {
      var _this = this;
      this.tableLoading = true;
      if (this.objData.repType == 'news') {
        if (this.newsType == '1') {
          getPageNews(Object.assign({
            current: page.currentPage,
            size: page.pageSize,
            appId: this.appId
          }, params)).then(function (response) {
            var tableData = response.data.data.items;
            tableData.forEach(function (item) {
              item.mediaId = item.articleId;
              item.content.articles = item.content.newsItem;
            });
            _this.tableData = tableData;
            _this.page.total = response.data.data.totalCount;
            _this.page.currentPage = page.currentPage;
            _this.page.pageSize = page.pageSize;
            _this.tableLoading = false;
          });
        } else if (this.newsType == '2') {
          getPageNewsDraft(Object.assign({
            current: page.currentPage,
            size: page.pageSize,
            appId: this.appId
          }, params)).then(function (response) {
            var tableData = response.data.data.items;
            tableData.forEach(function (item) {
              item.mediaId = item.mediaId;
              item.content.articles = item.content.newsItem;
            });
            _this.tableData = tableData;
            _this.page.total = response.data.data.totalCount;
            _this.page.currentPage = page.currentPage;
            _this.page.pageSize = page.pageSize;
            _this.tableLoading = false;
          });
        }
      } else {
        _getPage(Object.assign({
          current: page.currentPage,
          size: page.pageSize,
          appId: this.appId,
          type: this.objData.repType
        }, params)).then(function (response) {
          _this.tableData = response.data.data.items;
          _this.page.total = response.data.data.totalCount;
          _this.page.currentPage = page.currentPage;
          _this.page.pageSize = page.pageSize;
          _this.tableLoading = false;
        });
      }
    },
    sizeChange: function sizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getPage(this.page);
    },
    currentChange: function currentChange(val) {
      this.page.currentPage = val;
      this.getPage(this.page);
    },
    /**
     * 刷新回调
     */
    refreshChange: function refreshChange(page) {
      this.getPage(this.page);
    }
  }
};